<template>
  <v-container class="d-flex flex-column" style="height: 100vh; max-width: 900px">
    <v-card outlined class="pa-6" style="width: 100%">
      <v-card-title class="justify-center">
        <span class="headline">Consulta de Solicitação</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" lazy-validation class="">
          <v-text-field
            v-model="formulario.protocolo"
            :rules="[rules.required]"
            label="Número de Protocolo"
            outlined
            dense
            required
            class="mb-4"
          />
          <v-text-field
            v-model="formulario.token"
            :rules="[rules.required]"
            label="Token"
            outlined
            dense
            required
            class="mb-2"
          />
          <div class="mb-4" style="margin-top: -10px">
            <a
              href="#"
              style="
                font-size: 0.97rem;
                color: #1976d2;
                text-decoration: underline;
                cursor: pointer;
              "
              @click.prevent="abrirModalReenvioToken"
            >
              Esqueceu seu token? Clique aqui para reenvia-lo.
            </a>
          </div>

          <v-dialog v-model="dialogReenvioToken" max-width="420">
            <v-card>
              <v-card-title
                class="headline justify-center grey-darken-5--text"
                style="color: #616161"
              >
                Reenviar Token
              </v-card-title>
              <v-card-subtitle class="mt-1 justify-center">
                Informe o número do protocolo e o tipo de solicitação para reenviar o token para o
                email cadastrado.
              </v-card-subtitle>
              <v-card-text>
                <v-text-field
                  v-model="reenvio.protocolo"
                  label="Número do Protocolo"
                  outlined
                  dense
                  required
                />
                <v-select
                  v-model="reenvio.tipoSolicitacao"
                  :items="tiposSolicitacao"
                  item-text="label"
                  item-value="value"
                  label="Tipo de Solicitação"
                  outlined
                  dense
                  required
                  class="mb-3"
                />
              </v-card-text>
              <v-card-actions>
                <v-btn text @click="dialogReenvioToken = false"> Cancelar </v-btn>
                <v-spacer />
                <v-btn
                  :disabled="!reenvio.tipoSolicitacao || !reenvio.protocolo"
                  color="primary"
                  @click="reenviarToken"
                >
                  Reenviar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <vue-recaptcha
            ref="recaptcha"
            :sitekey="siteKey"
            :load-recaptcha-script="true"
            class="mb-4"
            @verify="verifyRecaptcha"
            @expired="expiredRecaptcha"
          />
          <v-btn color="primary" :disabled="formValid" block @click="search"> Acessar </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
    <dialog-consultar-solicitacao
      :dialog="dialog"
      :resultado="resultado"
      @update:dialog="dialog = $event"
      @update:solicitacao="search"
    />
  </v-container>
</template>

<script>
import { VUE_APP_RECAPTCHA_KEY } from '@/commons/config';
import VueRecaptcha from 'vue-recaptcha';
import DialogConsultarSolicitacao from './components/DialogConsultarSolicitacao.vue';
import solicitacaoService from '@/services/spgc/solicitacao.service';
import { mapState } from 'vuex';
import GlobalStore from '@/store/modules/global';

export default {
  name: 'ConsultarSolicitacao',
  components: {
    VueRecaptcha,
    DialogConsultarSolicitacao,
  },
  data() {
    return {
      tiposSolicitacao: [],
      protocolo: '',
      token: '',
      captchaChecked: false,
      formValid: '',
      formulario: {
        protocolo: '',
        token: '',
        recaptcha: '',
      },
      siteKey: VUE_APP_RECAPTCHA_KEY,
      rules: {
        required: v => !!v || 'Campo obrigatório',
        captcha: v => v || 'Confirme o captcha',
      },
      dialog: false,
      dialogReenvioToken: false,
      reenvio: {
        tipoSolicitacao: '',
        protocolo: '',
      },
      resultado: {
        nomeEmpresa: '',
        cnpj: '',
        protocolo: '',
        tipoAgente: '',
        dataSolicitacao: '',
        status: '',
        arquivos: [],
        nup: '',
        statusSuite: '',
      },
    };
  },

  watch: {
    formulario: {
      deep: true,
      handler(newValue) {
        // Verifica se algum campo do formulário está vazio
        const algumVazio = Object.values(this.formulario).includes('');
        this.formValid = algumVazio;
      },
    },
  },
  mounted() {
    this.documentosOrdenados();
    // Carrega os tipos de solicitação para o select
    this.carregarTiposSolicitacao();
  },
  methods: {
    search() {
      solicitacaoService
        .getSolicitacaoByProtocoloAndToken(this.formulario.token, this.formulario.protocolo)
        .subscribe({
          next: response => {
            const { result } = response;
            this.documentosOrdenados(result);
            solicitacaoService
              .signinToUploadDoc(this.formulario.protocolo, this.formulario.token)
              .subscribe(
                response => {
                  localStorage.setItem(this.formulario.protocolo, response.token);
                },
                error => {
                  console.error('Signin failed', error);
                }
              );
          },
          error: error => {
            const { response: data } = error;
            GlobalStore.setSnackBar({
              show: true,
              message: data?.data.message || 'Erro ao buscar solicitação.',
              type: 'error',
            });
          },
        });
    },
    verifyRecaptcha(value) {
      this.formulario.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.formulario.recaptcha = '';
    },
    abrirModalReenvioToken() {
      this.dialogReenvioToken = true;
      this.reenvio.tipoSolicitacao = '';
      this.reenvio.protocolo = '';
    },
    reenviarToken() {
      solicitacaoService
        .reenviarToken(this.reenvio.protocolo, this.reenvio.tipoSolicitacao)
        ?.subscribe(
          next => {
            GlobalStore.setSnackBar({
              show: true,
              message: next.message,
              type: 'success',
            });
            this.dialogReenvioToken = false;
          },
          error => {
            this.$toast?.error?.('Erro ao reenviar token.');
          }
        );
    },
    documentosOrdenados(result) {
      // Junta rejeitados primeiro, depois aprovados
      if (!result) return;

      this.resultado = result;
      const rejeitados = (result?.arquivos || []).filter(doc => !doc.aprovado);
      const aprovados = (result?.arquivos || []).filter(doc => doc.aprovado);

      this.resultado.arquivos = [...rejeitados, ...aprovados];
      this.dialog = true;

      return [...rejeitados, ...aprovados];
    },
    carregarTiposSolicitacao() {
      // Busca as regras e extrai os tipos únicos
      solicitacaoService.getRegrasValidacao().subscribe({
        next: response => {
          const regras = response.result || [];
          // Extrai os tipos únicos
          const tipos = Array.from(new Set(regras.map(r => r.tipoSolicitacao))).map(tipo => ({
            label: this.formatarTipoSolicitacao(tipo),
            value: tipo,
          }));
          this.tiposSolicitacao = tipos;
        },
        error: () => {
          this.tiposSolicitacao = [];
        },
      });
    },
    formatarTipoSolicitacao(tipo) {
      if (!tipo) return '';
      return tipo
        .toLowerCase()
        .replace(/_/g, ' ')
        .replace(/(^|\s)\S/g, l => l.toUpperCase());
    },
  },
};
</script>

<style scoped></style>
